import * as React from 'react'
import DataGrid, { DataGridHandle, DataGridProps } from 'react-data-grid'
import { useRsi } from '../hooks/useRsi'

interface Props<Data> extends DataGridProps<Data> {
    // `rowHeight` vem do DataGridProps e aceita número ou função (altura por linha) — redeclará-lo
    // aqui como número impedia a linha expandida da Task #66347.
    hiddenHeader?: boolean
    // Task #66347: dá acesso ao `selectCell(posição, abrirEditor)` do grid, que é o que permite abrir
    // a edição ao segundo clique sobre uma célula já selecionada.
    gridRef?: React.Ref<DataGridHandle>
}

export const Table = <Data,>({ className, gridRef, ...props }: Props<Data>) => {

    // function rowClass(row: Data) {
    //     return styles.row;
    // }


    const { rtl } = useRsi()
    return <DataGrid ref={gridRef} defaultColumnOptions={{ resizable: true }}  className={'rdg-light ' + className || ''} direction={rtl ? 'rtl' : 'ltr'} {...props} />
}
